var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3643 2H19.3643C19.6295 2 19.8838 2.10536 20.0714 2.29289C20.2589 2.48043 20.3643 2.73478 20.3643 3V19C20.3643 19.2652 20.2589 19.5196 20.0714 19.7071C19.8838 19.8946 19.6295 20 19.3643 20H1.36426C1.09904 20 0.844687 19.8946 0.657151 19.7071C0.469615 19.5196 0.364258 19.2652 0.364258 19V3C0.364258 2.73478 0.469615 2.48043 0.657151 2.29289C0.844687 2.10536 1.09904 2 1.36426 2H5.36426V0H7.36426V2H13.3643V0H15.3643V2ZM13.3643 4H7.36426V6H5.36426V4H2.36426V8H18.3643V4H15.3643V6H13.3643V4ZM18.3643 10H2.36426V18H18.3643V10Z",
    fill: "#093549"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCal);
export default __webpack_public_path__ + "static/media/cal.f40cc809277b8c1310f762cf18049ce1.svg";
export { ForwardRef as ReactComponent };